<template>
    <div class="recommendet-loader shimmer"></div>
</template>

<script>
export default {
    name: "RecommendetLoader",
};
</script>

<style scoped>
.recommendet-loader {
    background: var(--loader-color);
    border-radius: 15px;
    width: 137px;
    height: 180px;
    padding: 8px 7px;
}

.shimmer {
    position: relative;
    overflow: hidden;
}

.shimmer::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg,
            transparent,
            var(--loader-animation-color),
            transparent);
    animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
    0% {
        transform: translateX(-100%);
    }

    100% {
        transform: translateX(100%);
    }
}
</style>
